import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaOrdini = () => {
  const [righeT, setRigheT] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnnidato = data?.ORDINI_URGENTI || [];
        const ordiniPiatto = arrayAnnidato.flat();

        const datiFiltrati = ordiniPiatto.filter((item) => {
          const isTipoT = item["Tipo Riga"] === "T";
          const haCliente = item["ID cliente"] !== null && item["ID cliente"] !== undefined && item["ID cliente"] !== "";
          const qtaDevValue = parseFloat(item["Qta DEV"]) || 0;
          const haQtaDev = qtaDevValue > 0;
          return isTipoT && haCliente && haQtaDev;
        });

        const sorted = datiFiltrati.sort((a, b) => new Date(b["Data Ordine"]) - new Date(a["Data Ordine"]));
        setRigheT(sorted);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore:", err);
        setError("Errore nel caricamento dei dati");
        setLoading(false);
      });
  }, []);

  const getRowColorClass = (dateString) => {
    if (!dateString) return "";
    const dataDoc = new Date(dateString.split(" ")[0]);
    const oggi = new Date();
    dataDoc.setHours(0, 0, 0, 0);
    oggi.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((oggi - dataDoc) / (1000 * 60 * 60 * 24));

    if (diffDays >= 15) return "ritardo-bordeaux";
    if (diffDays >= 7) return "ritardo-rosso";
    if (diffDays >= 3) return "ritardo-rosa";
    return "";
  };

  const handleSort = () => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);
    const sortedData = [...righeT].sort((a, b) => {
      const dateA = new Date(a["Data Ordine"]);
      const dateB = new Date(b["Data Ordine"]);
      return newOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
    setRigheT(sortedData);
  };
  
  return (
    <div
      className="bg-dark text-light widget-client2 ombra tb"
      style={{ 
        borderRadius: "10px", 
        border: "1px solid #c2c2c2",
        position: "relative",
        height: "400px", // ALTEZZA FISSA NECESSARIA
        display: "flex",
        flexDirection: "column",
        overflow: "hidden" 
      }}
    >
      <div className="py-2 text-center border-secondary bg-dark" style={{ zIndex: 11 }}>
        <span className="text-title" style={{ fontWeight: "bold", fontSize: "0.85rem", color: "#aaa" }}>ORDINI URGENTI</span>
      </div>

      <style>{`
        /* Container scrollabile */
        .scroll-area {
          overflow-y: auto;
          flex-grow: 1;
        }
        
        /* Nascondi scrollbar per estetica */
        .scroll-area::-webkit-scrollbar { display: none; }
        .scroll-area { scrollbar-width: none; }

        .table-custom { 
          border-collapse: separate; 
          border-spacing: 0; 
          width: 100%;
          margin-bottom: 0;
        }

        .table-custom thead th {
          position: sticky;
          top: 0;
          z-index: 10;
          background-color: #212529 !important; /* bg-dark */
          color: white !important;
          cursor: pointer;
          font-size: 0.75rem;
          white-space: nowrap;
        }
        
        .ritardo-rosa td { background-color: #ffd1dc !important; color: #000 !important; }
        .ritardo-rosso td { background-color: #ff3e3e !important; color: #fff !important; }
        .ritardo-bordeaux td { background-color: #800020 !important; color: #fff !important; }
        .bg-white-custom { background-color: #ffffff !important; color: #333 !important; }
      `}</style>

      <div className="scroll-area">
        <Table hover className="table-custom" style={{ fontSize: "0.8rem" }}>
          <thead>
            <tr>
              <th>Ragione sociale</th>
              <th>BEM</th>
              <th onClick={handleSort}>Data Ordine {sortOrder === "asc" ? "↑" : "↓"}</th>
              <th>Tipo Doc</th>
              <th>Num Doc</th>
              <th>Importo</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="6" className="text-center bg-white-custom">Caricamento...</td></tr>
            ) : error ? (
              <tr><td colSpan="6" className="text-center text-danger bg-white-custom">{error}</td></tr>
            ) : (
              righeT.map((row, index) => {
                const colorClass = getRowColorClass(row["Data Ordine"]);
                const cellClass = !colorClass ? "bg-white-custom" : "";
                return (
                  <tr key={index} className={colorClass}>
                    <td className={cellClass}>{row["Ragione sociale"]}</td>
                    <td className={cellClass}>{row["BEM"]}</td>
                    <td className={cellClass}>{row["Data Ordine"]?.split(" ")[0] || "-"}</td>
                    <td className={cellClass}>{row["Tipo Doc"]}</td>
                    <td className={cellClass}>{row["Num Doc"]}</td>
                    <td className={cellClass}>
                      {row["Importo"] ? parseFloat(row["Importo"]).toFixed(2) : "0.00"} €
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TabellaOrdini;